import { request } from './client';

export function fetchCustomerFeatures() {
  return request('GET', '/v1/account/features', {});
}
